// core version + navigation, pagination modules:
import Swiper from 'swiper/core';

/**
 * initializeBlock
 *
 * Adds custom JavaScript to the block HTML.
 *
 * @date    15/4/19
 * @since   1.0.0
 *
 * @param   object $block The block jQuery element.
 * @param   object attributes The block attributes (only available when editing).
 * @return  void
 */
var initializeBlock = function ( $block, $index ) {
    const swiper = new Swiper($block.find('.swiper-container')[0], {
      // Optional parameters
        direction: 'horizontal',

        slidesPerView: 3,
        spaceBetween: 30,

        breakpoints: {
          // when window width is >= 320px
            200: {
                slidesPerView: 1.1,
                spaceBetween: 10,
                centeredSlides: false,
            },
          // when window width is >= 480px
            768: {
                slidesPerView: 2,
                spaceBetween: 30,
            },
          // when window width is >= 640px
            1024: {
                slidesPerView: 3,
                spaceBetween: 30,
            }
        }
    });

  $block.find('.slider-button-next').click(e => {
    e.preventDefault()
    swiper.slideNext();
  })

  $block.find('.slider-button-prev').click(e => {
    e.preventDefault()
    swiper.slidePrev();
  })

}

// Initialize each block on page load (front end).
$(document).ready(function () {
    $('.post-archive').each(function (index, element) {
        $(this).addClass('s' + index);
        initializeBlock($(this), index);
    });
});

// Initialize dynamic block preview (editor).
if ( window.acf ) {
    window.acf.addAction('render_block_preview/type=PostArchive', initializeBlock);
}
